import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { User, Wallet, ReceiptText } from "lucide-react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


const kpiCards = [
  {
    label: "Total Booking Count",
    value: "452",
    icon: (
      <User className="w-7 h-7 text-[#F3B753] bg-[#232323] rounded-full p-1" />
    ),
  },
  {
    label: "Total Amount",
    value: "€ 7,800",
    icon: (
      <Wallet className="w-7 h-7 text-[#F3B753] bg-[#232323] rounded-full p-1" />
    ),
  },
  {
    label: "Total Tax",
    value: "€ 780",
    icon: (
      <ReceiptText className="w-7 h-7 text-[#F3B753] bg-[#232323] rounded-full p-1" />
    ),
  },
];

const Stats = ({
  handleStartDate,
  handleEndDate,
  handlegetData,
  startDate,
  endDate,
  showtiles,
}) => {
  const location = useLocation();
  const isCarListingsRoute = location.pathname === "/car-listings";
 
  return (
    <>
      <div className="flex flex-row mb-5">
        <div>
          Start Date:
          <DatePicker
            className="customDate"
            selected={startDate}
            onChange={handleStartDate}
            dateFormat="dd-MM-yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText="Start Date"
            wrapperClassName="datePicker"
          />
        </div>
        <div className="ml-5">
          End Date:
          <DatePicker
            className="customDate"
            selected={endDate}
            onChange={handleEndDate}
            dateFormat="dd-MM-yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText="End Date"
            wrapperClassName="datePicker"
          />
        </div>
        <div>
          <button
            className="getData flex flex-row items-center gap-2  h-8 px-6 py-2 ml-[25px] box-border"
            type="button"
            onClick={handlegetData}
          >
            <span className="font-poppins text-xs leading-[18px] text-[#F6F6F6] font-normal">
              Fetch Data
            </span>
          </button>
        </div>
      </div>

      {showtiles && (
        <div className="grid grid-cols-3 gap-10">
          {kpiCards.map((card, i) => (
            <div
              key={i}
              className="bg-[#181818] border border-[#232323] rounded-xl flex flex-col justify-between px-[33px] py-4 min-h-[120px]"
            >
              <div className="flex flex-row items-center justify-between w-full">
                <div className="text-2xl font-bold text-left">{card.value}</div>
                <div className="bg-[#232323] rounded-full p-2 flex items-center justify-center">
                  {card.icon}
                </div>
              </div>
              <div className="text-[#bdbdbd] text-sm mt-2 text-left">
                {card.label}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Stats;
